<h1 mat-dialog-title>Einzelpreis f&uuml;r {{ data?.artikel }} anpassen</h1>
<div mat-dialog-content>
    <mat-form-field>
        <mat-label>Einzelpreis (Euro)</mat-label>
        <input [formControl]="einzelpreisCtrl" matInput type="number" step="0.01" />
    </mat-form-field>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Abbrechen</button>
    <button mat-flat-button color="accent" [disabled]="isLoading || einzelpreisCtrl?.invalid" (click)="submit()">
        Speichern
    </button>
</div>
